<script>
export default {
    name: "PrintGatePass",

    data() {

        return {
            patient: {},
        };
    },

    mounted() {
        this.$root.loading=true;
        this.fetchGatePass().then(response => {
            let dischargeDetails = response.data.dischargeDetails;
            this.patient = dischargeDetails.length ? dischargeDetails[0] : {};
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchGatePass() {
            let url = `Admissions/GatePass`;
                url += `?PatientID=${this.$route.params.patientID}`;
                url += `&DateAdmitted=${this.$route.params.dateAdmitted}`;

            return this.$http.get(url);
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full flex flex-col my-2 border-t-2 border-gray-800">
            <!-- <div class="w-full text-center my-1 p-2">
                <h5 class="font-bold text-base uppercase">Gate pass</h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Patient Names: 
                   {{ patient.names }}</h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">MRN: 
                    {{ $route.params.patientID }}</h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">IP. No: 
                    {{ patient.ipfileno }}</h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Admitted On: 
                    {{ patient.dateAdmitted | dateFormat }}</h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Discharged On: 
                    {{ patient.trxDate | dateFormat }}</h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Ward: 
                    {{ patient.ward }}</h5>
            </div>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Bed: 
                   {{ patient.bed }}</h5>
            </div> -->
            <table style="border-bottom-color: Gray;  border-bottom-style: solid; border-top-color: Gray; border-top-style: solid; font-family: Lucida Bright; font-weight: bold; padding-top: 0; width: 100%;">
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Patient Names
        </td>
        <td>:
        </td>
        <td>
            {{ patient.names }}
        </td>
    </tr>
   
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>MRN
        </td>
        <td>:
        </td>
        <td align="Left">
             
                    <span >{{ $route.params.patientID }}</span> 
        </td>
    </tr>
    
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>IP. No
        </td>
        <td>:
        </td>
        <td align="Left">
            {{ patient.ipfileno || `-` }}
        </td>
    </tr> <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Admitted On
        </td>
        <td>:
        </td>
        <td align="Left">
            {{ patient.dateAdmitted | dateFormat }}
        </td>
    </tr>
    
    
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Discharged On
        </td>
        <td>:
        </td>
        <td align="Left">{{ patient.trxDate | dateFormat }}
        </td>
    </tr>
     
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>No Of Days
        </td>
        <td>:
        </td>
        <td align="Left">
            {{ patient.days }}  
        </td>
    </tr> <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Ward ________
        </td>
        <td>:
        </td>
        <td align="Left">
           Bed ________
        </td>
    </tr>
    
    <!-- <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Cleared By
        </td>
        <td>:
        </td>
        <td align="Left">
            {{ patient.approvedBy }}
        </td>
    </tr>  -->
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Nurse Name
        </td>
        <td>:
        </td>
        <td align="Left">
           ___________________________
        </td>
    </tr> <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Nurse Signature
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Nurse Aid Name
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Nurse Aid Signature
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
    <tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Security 
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr><tr>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Security Signature
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
    <tr v-if="$root.checkAuth('GatePassSignatoris')">
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Cleared by Finance Name
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
    <tr v-if="$root.checkAuth('GatePassSignatoris')">
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Cleared by Finance Signature
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
    <tr v-if="$root.checkAuth('GatePassSignatoris')">
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Cleared by Pharmacy Name
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
    <tr v-if="$root.checkAuth('GatePassSignatoris')">
        <td>&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
        <td>Cleared by Pharmacy Signature
        </td>
        <td>:
        </td>
        <td align="Left">
            ___________________________
        </td>
    </tr> 
</table>
            <div class="w-full flex justify-center my-1">
                <h5 class="font-bold text-base uppercase">Printed By: 
                    {{ $root.username }}</h5>
            </div>
        </div>
    </div>
</template>